export default __webpack_public_path__ + "static/media/GustavAttackPortal.995f6745.png";